export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "这个站收录的都是什么类型的火影同人动漫？",
    a: "本站主要按剧情类型整理火影同人作品，覆盖穿越、系统、重生、日常、战斗等热门方向。你可以直接点击导航或首页分类卡片，快速进入对应类型的作品列表，找到符合自己口味的作品。",
  },
  {
    q: "穿越、系统、重生这类分类有什么区别？",
    a: "穿越指主角从现实或其他世界进入忍界重新开始；系统通常指主角绑定金手指系统获得能力；重生则指主角带着记忆回到过去改写剧情。日常偏温馨轻松，战斗偏热血对决。每个分类都做了单独整理，方便精准定位。",
  },
  {
    q: "更新频率如何，会不会及时提醒？",
    a: "我们会持续跟进各作品的更新情况，并优先展示最近更新的作品。首页的『最新更新』板块会集中呈现近期有更新的作品，方便你第一时间掌握追更进度，不迷路。",
  },
  {
    q: "为什么有些作品标注『连载中』有些是『已完结』？",
    a: "『连载中』表示作品仍在持续更新，『已完结』表示故事已经收尾。你可以在卡片和详情页看到对应的状态标识，也可以按状态筛选，选择只看连载中的作品或已完结的作品。",
  },
  {
    q: "作品的评分和热度是怎么来的？",
    a: "评分和热度是综合读者反馈与作品热度整理的参考指标，帮助你快速判断作品的受欢迎程度。具体的观感还需要结合简介、标签和自身喜好来判断，建议先看简介再决定是否追更。",
  },
  {
    q: "在哪儿能看到作品的详细剧情介绍？",
    a: "点击任意作品卡片即可进入作品详情页，页面会展示完整简介、标签、类型、作者、章节数和更新状态，同时会为你推荐同类型的相关作品，方便继续浏览。",
  },
];